<template>
  <div class="scroll-y" style="position: relative; height: 100%; background-color: #ffffff;">
    <!-- Slider melletti gombok navigációs gombok (Csak az elhelyezésével kell foglalkoznod) -->
    <div v-if="!isLoading" id="nav-txt-container">
      <!-- Szerkesztés -->
      <div
        v-if="getCurrentUser && !isInfoObjectEmpty && !isEdit"
        @click="isEdit = true; isNew = false; cloneInfoObject()"
        id="nav-txt-edit"
      >
        <img src="@/assets/ntk_nav_edit_g.svg">
      </div>

      <!-- Törlés -->
      <v-dialog
        v-if="getCurrentUser && !isInfoObjectEmpty && !isEdit"
        v-model="isShowDeleteDialog"
        persistent
        lazy
        max-width="500px"
        transition="dialog-transition"
      >
        <div slot="activator" id="nav-txt-delete">
          <img src="@/assets/ntk_nav_delete_g.svg">
        </div>
        <v-card>
          <v-card-text class="headline">{{`${infoObject.title} törlése`}}</v-card-text>
          <v-card-text
            class="font-weight-bold"
          >Biztosan törli? (A törlés elfogadásával törlődik a fordítás!)</v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :disabled="isLoading" @click="isShowDeleteDialog = false;">Mégse</v-btn>
            <v-btn :loading="isLoading" @click="deleteData()">Törlés</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Hozzáadás -->
      <div
        v-if="getCurrentUser != null && !isEdit && isInfoObjectEmpty"
        @click="isEdit = true; isNew = true; clonedInfoObject = {};"
        id="nav-txt-add"
      >
        <img src="@/assets/ntk_nav_add_g.svg">
      </div>

      <!-- MEntés -->
      <div v-if="getCurrentUser && isEdit && isNew" @click="saveData();" id="nav-txt-save">
        <img src="@/assets/ntk_nav_save_g.svg">
      </div>
      <!-- IDE IS A MENTÉS GOMBOT -->
      <!-- Módosítás -->
      <div v-if="getCurrentUser && isEdit && !isNew" @click=" updateData();" id="nav-txt-save">
        <img src="@/assets/ntk_nav_save_g.svg">
      </div>

      <!-- Mégse -->
      <div
        v-if="getCurrentUser && isEdit"
        @click="isEdit = false; clonedInfoObject = {}; isNew = false;"
        id="nav-txt-cancel"
      >
        <img src="@/assets/ntk_nav_cancel_g.svg">
      </div>
    </div>

    <!--LOADER-->
    <v-layout v-if="isLoading" fill-height justify-center align-center row wrap>
      <v-progress-circular indeterminate></v-progress-circular>
    </v-layout>

    <!-- Nincs kiválasztva dokumentum -->
    <v-layout
      v-else-if="isInfoObjectEmpty && !isEdit"
      class="text-xs-center"
      row
      wrap
      fill-height
      align-center
      justify-center
    >
      <v-flex xs12>
        <div style="color: #323639;">A dokumentumhoz még nem töltöttek fel fordítást</div>
      </v-flex>
    </v-layout>

    <!-- Ha szerkesztésre van megnyitva a felület (itt csak a text fieldek a fontosak a többit módosíthatod) -->
    <v-container
      v-else-if="isEdit && getCurrentUser"
      grid-list-xs
      class="ma-0"
      style="background-color: white"
    >
      <!-- Beviteli mezők -->
      <v-layout row wrap fluid>
        <v-flex xs12>
          <v-text-field
            light
            :value="clonedInfoObject.title"
            @input="clonedInfoObject.title = $event"
            v-validate="'required'"
            :error-messages="errors.collect('title')"
            data-vv-name="title"
            label="Cím"
            class="mb-3 pt-0"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            :value="clonedInfoObject.sub_title"
            @input="clonedInfoObject.sub_title = $event"
            :error-messages="errors.collect('sub_title')"
            data-vv-name="sub_title"
            label="Alcím"
            class="mb-3 pt-0"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            :value="clonedInfoObject.section_title"
            @input="clonedInfoObject.section_title = $event"
            :error-messages="errors.collect('section_title')"
            data-vv-name="section_title"
            label="Szakaszcím"
            class="mb-3 pt-0"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-textarea
            outline
            :value="clonedInfoObject.text"
            @input="clonedInfoObject.text = $event"
            v-validate="'required'"
            :error-messages="errors.collect('text')"
            data-vv-name="text"
            label="Szöveg"
            class="mb-3 pt-0"
            wrap="hard"
          ></v-textarea>
        </v-flex>
        <v-flex xs12>
          <!-- Hivatkozsoknak is egy textfield-et adtam meg, mert ez nem tudom hogy hogyan lesz
          (Erről majd konzultáljunk)-->
          <v-text-field
            :value="clonedInfoObject.reference"
            @input="clonedInfoObject.reference = $event"
            label="Hivatkozások"
            class="mb-3 pt-0"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- Szöveges megjelenítés (ezeket kell rendesen formáznod)-->
    <div id="txt-container" v-else>
      <h1 v-if="infoObject && infoObject.title" id="title">{{infoObject.title}}</h1>
      <h1 v-if="infoObject && infoObject.sub_title" id="subtitle">{{infoObject.sub_title}}</h1>
      <h1
        v-if="infoObject && infoObject.section_title"
        id="section-title"
      >{{infoObject.section_title}}</h1>
      <h1 v-if="infoObject && infoObject.text" id="text">{{infoObject.text}}</h1>
      <h1 v-if="infoObject && infoObject.reference" id="reference">{{infoObject.reference}}</h1>
    </div>
  </div>
</template>

<script>
import { documentInfoCollection } from "../firebaseConfig";
import { mapGetters } from "vuex";
import Raven from "raven-js";

export default {
  name: "DocumentInfo",
  data() {
    return {
      infoObject: {},
      clonedInfoObject: {},
      isLoading: false,
      isEdit: false,
      isNew: false,
      requestTimeout: {},
      isShowDeleteDialog: false
    };
  },
  watch: {
    $route: function(val) {
      this.isLoading = false;
      this.setData();
    }
  },
  computed: {
    ...mapGetters(["getCurrentUser"]),
    isInfoObjectEmpty() {
      return _.isEmpty(this.infoObject);
    }
  },
  methods: {
    cloneInfoObject() {
      this.clonedInfoObject = _.cloneDeep(this.infoObject);
    },
    setData() {
      const documentId = this.$route.query.document;
      const pageId = this.$route.query.page;
      this.isEdit = false;
      clearTimeout(this.requestTimeout);
      if (documentId != null && pageId != null) {
        this.isLoading = true;
        this.requestTimeout = setTimeout(() => {
          documentInfoCollection
            .where("document_id", "==", documentId)
            .where("page_uid", "==", Number(pageId))
            .limit(1)
            .get()
            .then(querySnapshot => {
              if (querySnapshot.empty) {
                this.infoObject = {};
                this.clonedInfoObject = {};
              } else {
                this.infoObject = _.cloneDeep(
                  querySnapshot.docs.map(doc => {
                    return { id: doc.id, ...doc.data() };
                  })[0]
                );
              }
            })
            .catch(err => {
              Raven.captureException(err);
              this.$notify({
                group: "app",
                text: `Hiba a fordítás betöltése közben!`,
                type: "error "
              });
            })
            .finally(() => {
              this.isLoading = false;
            });
        }, 1500);
      }
    },
    saveData() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          const documentId = this.$route.query.document;
          const pageId = this.$route.query.page;
          this.isLoading = true;
          documentInfoCollection
            .add({
              document_id: documentId,
              page_uid: Number(pageId),
              ...this.clonedInfoObject
            })
            .then(() => {
              this.setData();
            })
            .catch(err => {
              Raven.captureException(err);
              this.$notify({
                group: "app",
                text: `Hiba a fordítás mentése közben:  ${err.message}`,
                type: "error "
              });
              this.isLoading = false;
            })
            .finally(() => {
              this.isEdit = false;
            });
        }
      });
    },
    updateData() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.isLoading = true;
          documentInfoCollection
            .doc(this.infoObject.id)
            .update({
              ..._.omit(this.clonedInfoObject, ["id"])
            })
            .then(() => {
              this.infoObject = _.cloneDeep(this.clonedInfoObject);
            })
            .catch(err => {
              Raven.captureException(err);
              this.$notify({
                group: "app",
                text: `Hiba a fordítás módosítása közben:  ${err.message}`,
                type: "error "
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.isEdit = false;
            });
        }
      });
    },
    deleteData() {
      this.isLoading = true;
      documentInfoCollection
        .doc(this.infoObject.id)
        .delete()
        .then(() => {
          this.infoObject = {};
          this.clonedInfoObject = {};
          this.isShowDeleteDialog = false;
        })
        .catch(err => {
          Raven.captureException(err);
          this.$notify({
            group: "app",
            text: `Hiba a fordítás törlése közben:  ${err.message}`,
            type: "error "
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  created() {
    this.setData();
  },
  destroyed() {
    clearTimeout(this.requestTimeout);
  }
};
</script>

<style>
#nav-txt-container {
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  height: auto;
  z-index: 1;
}

#nav-txt-edit,
#nav-txt-cancel,
#nav-txt-add,
#nav-txt-save,
#nav-txt-delete {
  width: 40px;
  height: 40px;
  cursor: pointer;
  transition: opacity 200ms ease-in-out;
}

#nav-txt-edit:hover,
#nav-txt-cancel:hover,
#nav-txt-add:hover,
#nav-txt-save:hover,
#nav-txt-delete:hover {
  opacity: 0.5;
}

#txt-container {
  padding: 30px;
  background-color: rgb(255, 255, 255);
}

#title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 30px;
}

#subtitle,
#section-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 30px;
}

#text {
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 30px;
  white-space: pre-line;
}

#reference {
  font-size: 10px;
  font-weight: 300;
}
</style>

